import { gql } from "@apollo/client";

export const LOGIN = gql`
  mutation loginUser($email: String!, $password: String!, $rememberMe: Boolean!) {
    loginUser(input: {loginAttributes: {email: $email, password: $password, rememberMe: $rememberMe}}) {
      token
      user {
        id
      }
    }
  }
`;

export const REGISTER = gql`
  mutation registerUser($fullName: String!, $email: String!, $password: String!, $passwordConfirmation: String!) {
    registerUser(input:{registerAttributes: {fullName: $fullName, email: $email, password: $password, passwordConfirmation: $passwordConfirmation}}) {
      token
      user {
        id
        email
      }
    }
  }
`;

export const UPDATE_USER = gql`
  mutation updateUser($id: ID!, $fullName: String!, $email: String!, $image: Upload) {
    updateUser(input:{profileAttributes: {id: $id, fullName: $fullName, email: $email, image: $image}}) {
      id
    }
  }
`;

export const CHANGE_PASSWORD = gql`
  mutation changePassword($id: ID!, $email: String!, $password: String!, $passwordConfirmation: String!) {
    changePassword(input:{changePasswordAttributes: {id: $id, email: $email, password: $password, passwordConfirmation: $passwordConfirmation}}) {
      id
    }
  }
`;

export const SET_PASSWORD = gql`
  mutation setPassword($resetPassword: Boolean!, $password: String!, $passwordConfirmation: String!, $token: String!) {
    setPassword(input: {setPasswordAttributes: {resetPassword: $resetPassword, password: $password, passwordConfirmation: $passwordConfirmation, token: $token}}) {
      token
    }
  }
`;

export const SEND_RESET_PASSWORD_INSTRUCTIONS = gql`
  mutation sendResetPasswordInstructions($email: String!) {
    sendResetPasswordInstructions(input: {email: $email}) {
      id
    }
  }
`;

export const BOOKMARK_LESSON = gql`
  mutation bookmark($id: ID!, $type: String!) {
    bookmark(input: {id: $id, type: $type}) {
      message
      result
    }
  }
`;

export const COMPLETED_LESSON = gql`
  mutation markAsCompleted($id: ID!) {
    markAsCompleted(input: {id: $id}) {
      message
      result
    }
  }
`;

export const QUIZ_ATTEMPT = gql`
  mutation createAttempt($quizId: ID!, $questionId: ID!, $answers: [AnswerAttributes!]!){
    createAttempt(
      input: {
        attemptAttributes: {
          quizId: $quizId,
          questionId: $questionId,
          answers: $answers
        }
      }
    ) {
      message
      result
    }
  }
`

export const RETAKE_QUIZ = gql`
  mutation retakeQuiz($id: ID!){
    retakeQuiz(
      input: {
        id: $id,
      }
    ) {
      message
      result
    }
  }
`

export const RETAKE_MOCK = gql`
  mutation retakeMock($mockId: ID!){
    retakeMock(
      input: {
        mockId: $mockId,
      }
    ) {
      message
      result
    }
  }
`

export const UPDATE_TIMER_MOCK = gql`
  mutation updateTimerMock($mockId: ID!, $timer: Int){
    updateTimer(
      input: {
        timerAttributes:{
          mockId: $mockId,
          timer: $timer
        }
      }
    ) {
      message
      result
    }
  }
`

export const MOCK_ATTEMPT = gql`
  mutation createMockAttempt($mockId: ID!, $mockSectionId: ID!, $questionId: ID!, $timer: Int, $answers: [AnswerAttributes!]!){
    createMockAttempt(
      input: {
        attemptAttributes: {
          mockId: $mockId,
          mockSectionId: $mockSectionId,
          questionId: $questionId,
          timer: $timer,
          answers: $answers
        }
      }
    ) {
      message
      result
    }
  }
`

export const MOCK_SECTION_ATTEMPT = gql`
  mutation createMockSectionAttempt($mockId: ID!, $mockSectionId: ID!){
    createMockSectionAttempt(
      input: {
        attemptAttributes: {
          mockId: $mockId,
          mockSectionId: $mockSectionId
        }
      }
    ){
      message
    }
  }
`

export const MOCK_ESSAY_ATTEMPT = gql`
  mutation createEssayAttempt($mockId: ID!, $essayId: ID!, $essayType: String!, $essayContent: String!, $timer: Float, $essayCompleted: Boolean, $conclusionWords: Float, $evidentiaryWords: Float, $numberParagraph: Float, $sentencePerParagraph: Float, $thesisWords: Float, $transitionWords: Float, $wordCount: Float, $wordsPerSentence: Float ){
    createEssayAttempt(
      input: {
        essayAttemptAttributes: {
          mockId: $mockId,
          essayId: $essayId,
          essayType: $essayType,
          essayContent: $essayContent,
          timer: $timer,
          essayCompleted: $essayCompleted,
          conclusionWords: $conclusionWords,
          evidentiaryWords: $evidentiaryWords,
          numberParagraph: $numberParagraph,
          sentencePerParagraph: $sentencePerParagraph,
          thesisWords: $thesisWords,
          transitionWords: $transitionWords,
          wordCount: $wordCount,
          wordsPerSentence: $wordsPerSentence
        }
      }
    ){
      message
    }
  }
`

export const BOOKMARK_QUESTION = gql`
  mutation bookmark($id: ID!, $type: String!) {
    bookmark(input: {id: $id, type: $type}) {
      message
      result
    }
  }
`;


export const RETAKE_PRACTICE_SET = gql`
  mutation retakePracticeSet($practiceSetId: ID!){
    retakePracticeSet(
      input: {
        practiceSetId: $practiceSetId,
      }
    ) {
      message
      result
    }
  }
`

export const CREATE_PRACTICE_SESSION = gql`
  mutation createPracticeSession($practiceSetId: ID!){
    createPracticeSession(
      input: {
        practiceSetId: $practiceSetId,
      }
    ) {
      id
      practiceSetId
    }
  }
`

export const PRACTICE_SET_ATTEMPT = gql`
  mutation createPracticeAttempt($timer: Int, $practiceSetId: ID!, $questionId: ID!, $answers: [AnswerAttributes!]!){
    createPracticeAttempt(
      input: {
        attemptAttributes: {
          timer: $timer,
          practiceSetId: $practiceSetId,
          questionId: $questionId,
          answers: $answers
        }
      }
    ) {
      message
      result
    }
  }
`

export const CLOSE_PRACTICE_SESSION = gql`
  mutation modifyPracticeSessionAccess($id: ID!, $closed: Boolean!){
    modifyPracticeSessionAccess(
      input: {
        id: $id,
        closed: $closed
      }
    ) {
      id
    }
  }
`